import type { HTMLAttributes } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../../lib/utils.js';

export const badgeVariants = cva(
  'inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium',
  {
    variants: {
      variant: {
        default: 'bg-accent-soft text-accent-soft-fg',
        secondary: 'bg-surface-2 text-text',
        outline: 'border border-border text-text',
        destructive: 'bg-[color-mix(in_srgb,var(--danger)_15%,transparent)] text-danger',
        success: 'bg-[color-mix(in_srgb,var(--success)_15%,transparent)] text-success',
      },
    },
    defaultVariants: { variant: 'default' },
  },
);

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement>, VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant, className }))} {...props} />;
}
